export interface AuthState {
  dsToken: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  reloginUrl: string | null;
}